import { IEquipmentProp } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentProp.dto';

import { THydrateAction } from '~/src/store';

export const SET_TICKET_ITEM = 'SET_TICKET_ITEM';
export const REMOVE_TICKET_ITEM = 'REMOVE_TICKET_ITEM';

export interface IPlan {
    id?: number,
    value: number, // Здесь хранится цена
    label: string,
    duration: number,
    type: number,
}

export enum ECategories {
    TARIFF = 'tariff',
    ANTIVIRUSES = 'antiviruses',
    PARENT_CONTROL = 'parentControl',
    ROUTERS = 'routers',
    WATCH_EVERYWHERE = 'watchEverywhere',
    VIEW_CONTROL = 'viewControl',
    ADDITIONAL_PRODUCTS = 'additionalProducts',
    CONNECTION = 'connection',
    DECODERS = 'decoders',
    LIKED_EQUIPMENTS = 'likedEquipments',
}

// @todo collect all product ids in the project and place it in one place
export enum EProductTypes {
    ROUTER = 5,
    DECODER = 53,
    YSTATION = 5,
}

/* TODO переработать структуру ITiketItem:
    - не конвертировать элементы помещаемые в эту сущность, а типизировать (для масштабируемости)
    - вынести отдельно хранение количества для не выбранного оборудования (для соблюдения single-responsibility)
*/
// Сущность - для хранения элементов составляющих стоимость тарифа
export interface ITicketItem {
    id: number,
    isSelected: boolean,
    name: string,
    price: number,
    count: number,
    promoPrice?: number,
    promoPeriod?: number,
    promoAvailable?: boolean,
    plan?: IPlan,
    plans?: IPlan[],
    image?: string,
    images?: string[],
    props?: IEquipmentProp[],
    description?: string,
    isRequired?: boolean,
    productId?: EProductTypes,
}

export interface ICategoryItem {
    [id: string]: ITicketItem,
}

export type TTicketState = {
    [category in ECategories]?: ICategoryItem;
};

const initialState:TTicketState = {};

export type TSetTicketItem = {
    type: typeof SET_TICKET_ITEM,
    payload: TTicketState,
};

export type TRemoveTicketItem = {
    type: typeof REMOVE_TICKET_ITEM,
    payload: TTicketState,
};

export type TActions = TSetTicketItem | TRemoveTicketItem;

export default (state = initialState, action: TActions | THydrateAction): TTicketState => {
    switch (action.type) {
        case SET_TICKET_ITEM:
        case REMOVE_TICKET_ITEM: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: return state;
    }
};
